var _circle, _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4697,
    cy: 25.533,
    r: 25,
    fill: "url(#paint0_linear_1061_11611)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1061_11611)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 17.533C10.9174 17.533 10.4697 17.9807 10.4697 18.533V34.533H9.46973C8.91744 34.533 8.46973 34.9807 8.46973 35.533V36.533C8.46973 37.0852 8.91744 37.533 9.46973 37.533H11.4697H39.4697H41.4697C42.022 37.533 42.4697 37.0852 42.4697 36.533V35.533C42.4697 34.9807 42.022 34.533 41.4697 34.533H40.4697V18.533C40.4697 17.9807 40.022 17.533 39.4697 17.533H11.4697Z",
    fill: "#30B8B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4697 16.533C10.4697 15.9807 10.9174 15.533 11.4697 15.533H39.4697C40.022 15.533 40.4697 15.9807 40.4697 16.533V34.533C40.4697 35.0852 40.022 35.533 39.4697 35.533H11.4697C10.9174 35.533 10.4697 35.0852 10.4697 34.533V16.533Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46973 33.533C8.46973 32.9807 8.91744 32.533 9.46973 32.533H41.4697C42.022 32.533 42.4697 32.9807 42.4697 33.533V34.533C42.4697 35.0852 42.022 35.533 41.4697 35.533H9.46973C8.91744 35.533 8.46973 35.0852 8.46973 34.533V33.533Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1878 28.442L15.4697 24.9421L19.1878 21.442L20.4697 22.6487L18.0331 24.9421L20.4697 27.2356L19.1878 28.442Z",
    fill: "#3EBCB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9897 28.442L30.708 27.2356L33.1444 24.9421L30.708 22.6487L31.9897 21.442L35.708 24.9421L31.9897 28.442Z",
    fill: "#3EBCB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4369 20.533L29.0889 21.4003L24.7411 30.533L23.0889 29.6654L27.4369 20.533Z",
    fill: "#3EBCB6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1061_11611",
    x: 5.75144,
    y: 14.8147,
    width: 39.4366,
    height: 25.4366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35914,
    result: "effect1_foregroundBlur_1061_11611"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1061_11611",
    x1: 58.7334,
    y1: 33.4216,
    x2: 32.6455,
    y2: -7.62915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36CFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAF9F6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIcon2);
export default __webpack_public_path__ + "static/media/stack-icon-2.751fc73ab622508c54b969600ca1b52b.svg";
export { ForwardRef as ReactComponent };